import {LegalAgentAgreementVo} from '../../common/shared/api/nicolas/vo/LegalAgentAgreementVo.interface';
import {AgreementContainer} from '../generated/types';
import {createAgreement} from './Agreement';

export function createLegalAgentAgreement(
  agreement: LegalAgentAgreementVo,
  isWebView: boolean
): AgreementContainer {
  return {
    itemList: agreement.agreement_under_14_list.map(item =>
      createAgreement(item, isWebView)
    ),
  };
}
